import AsyncComponent from "./AsyncComponent";

export default AsyncComponent;


// WEBPACK FOOTER //
// ./src/components/AsyncComponent/index.ts